import { z } from "zod";
import {
  COMPANY_DESC,
  COMPANY_NAME,
  EXP_REQ,
  JOB_DESC,
  JOB_ROLE,
  JOB_TITLE,
  LOCATION,
  REQ_SKILLS,
  STATUS,
} from "./consts";

export const schema = z.object({
  [JOB_TITLE]: z.string().optional(),
  [JOB_ROLE]: z.string().min(1, "This field is required"),
  [LOCATION]: z.string().min(1, "This field is required"),
  [JOB_DESC]: z.string().min(1, "This field is required"),
  [REQ_SKILLS]: z.string().min(1, "This field is required"),
  [EXP_REQ]: z.string().min(1, "This field is required"),
  [COMPANY_NAME]: z.string().min(1, "This field is required"),
  [COMPANY_DESC]: z.string().min(1, "This field is required"),
  [STATUS]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
